// ** React Imports
import { lazy } from 'react';

const AreaRoutes = [
  {
    path: 'area',
    component: lazy(() => import('pages/area')),
  },
];

export default AreaRoutes;
